


















































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {WaterfallSettings} from '@/interfaces/diagrams';
import SimpleDialog from '@c/SimpleDialog.vue';
import {spectrumYAxisTypes} from '@/api/configurate';

@Component({
  components: {SimpleDialog},
})
export default class WaterfallSettingsDialog extends Vue {
  dialog = false;

  get spectrumYAxisTypes() {
    return spectrumYAxisTypes;
  }

  @Watch('dialog')
  onDialog(value: boolean) {
    if (!value) this.updateSelectBtnState();
  }

  selectSettingsBtnIndex: number | null = null;

  @Prop({required: false, default: false})
  disabled!: boolean;

  @Prop({required: true})
  settings!: WaterfallSettings;

  dialogSettings: WaterfallSettings = {...this.settings};

  @Watch('settings')
  setDialogSettings(settings: WaterfallSettings) {
    this.dialogSettings = {...settings};
  }

  onClickCancelSelect() {
    this.dialog = false;
    this.dialogSettings = {...this.settings};
  }

  onApplySettings() {
    this.dialog = false;
    this.updateSelectBtnState();
    this.$emit('select', this.dialogSettings);
  }

  btnActiveState = false;
  updateSelectBtnState() {
    this.btnActiveState = this.dialog;
    this.selectSettingsBtnIndex = this.dialog ? 0 : null;
  }
}
